import { useState, useEffect, useContext, memo } from "react";
import styles from "./index.module.scss";
import feedbackIcon from "../../../../assets/images/feedback.png";
import { isMobileDevice } from "../../../../utils/getPlatformInfo";
import Feedback from "../Feedback";
import { ContainerBox } from "../../../../components/ShimmerEffect";
import Certificate from "../Certificate/Certificate";
import { useWebinarPageContext } from "../..";
import SessionDetails from "../SessionDetails/SessionDetails";
import InviteModal from "../../../../components/InviteModal/InviteModal";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import {
  CERTIFICATE_CLICK,
  FEEDBACK_CLICK,
  INVITEYOURFRIEND_EVENT_BTN,
  WEBINAR_SHARE_CLICK,
} from "../../../../AppConstants/AnalyticsEventName";
import { ContentType2 } from "../../../../AppConstants/TypeConstants";
import QNAImg from "../../../../assets/images/Q&A.png";
import { scrollTarget, showToast } from "../../../../utils/common.utils";
import { webinarContext } from "../../../../contexts/WebinarContext/WebinarContextProvider";

function WebinarHeader({
  details,
  isOpen,
  setIsOpen,
  showPollIndicator,
  overlay,
  showTabDirectly = false,
}) {
  const { state: webinarPageData } = useWebinarPageContext();
  const { addGAWithUserInfo } = useContext(AnalyticsContext);
  const {
    thumbnailUrl = "",
    title = "",
    description = "",
    webinarLogo,
  } = details || {};
  const { isUserAlreadySubmittedFeedback } = useContext(webinarContext);

  const [showFeedback, setShowFeedback] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showCertificate, setShowCertificate] = useState(false);
  const [showCertificateBtn, setShowCertificateBtn] = useState(false);
  const [showSessionDetails, setShowSessionDetails] = useState(false);
  const [certificateShowTime, setCertificateShowTime] = useState({
    minutes: 3,
    seconds: 0,
  });
  const [feedbackkey, setFeedbackkey] = useState(0);
  useEffect(() => {
    let myInterval = null;

    if (details.isCertificateEnable) {
      if (details.isCertificateTimerEnable) {
        myInterval = setInterval(() => {
          const showBtn = () => {
            clearInterval(myInterval);
            setShowCertificateBtn(details.isCertificateEnable);
          };

          setCertificateShowTime((prev) => {
            if (prev.seconds > 0) {
              return { minutes: prev.minutes, seconds: prev.seconds - 1 };
            } else if (prev.seconds === 0) {
              if (prev.minutes > 0) {
                return {
                  minutes: prev.minutes - 1,
                  seconds: 59,
                };
              } else if (prev.minutes === 0) {
                showBtn();
                return {
                  minutes: 0,
                  seconds: 0,
                };
              }
            }
          });
        }, 1000);
      } else {
        setCertificateShowTime({ minutes: 0, seconds: 0 });
        setShowCertificateBtn(details.isCertificateEnable);
      }
    } else {
      clearInterval(myInterval);
    }

    return () => {
      clearInterval(myInterval);
    };
  }, [details.isCertificateEnable]);
  useEffect(() => {
    if (showInviteModal || showFeedback) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showInviteModal, showFeedback]);

  const handleFeedbackClose = () => {
    setShowFeedback(false);
  };
  const handleFeedbackOpen = async () => {
    try {
      if (await isUserAlreadySubmittedFeedback(details.id)) {
        showToast("You have already submitted feedback");
        return;
      }
      addClickAnalytics(FEEDBACK_CLICK);
      setShowFeedback(true);
      setFeedbackkey((prev) => prev + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCertificateBtn = () => {
    addClickAnalytics(CERTIFICATE_CLICK);
    setShowCertificate(true);
  };

  const addClickAnalytics = (eventName) => {
    addGAWithUserInfo(eventName, { eventId: details.id, ...details });
  };

  const handleInviteBtn = () => {
    addClickAnalytics(WEBINAR_SHARE_CLICK);
    setShowInviteModal(true);
  };

  const handleInviteBtnClose = () => {
    setShowInviteModal(false);
  };

  const handleCertificateClose = () => {
    setShowCertificate(false);
  };

  return (
    <div>
      <div
        className={`${styles.webinarHeader} ${
          overlay && styles.webinarHeaderOverlay
        }`}
      >
        <div className={styles.row}>
          <div
            style={{
              width: isMobileDevice ? "3rem" : "6.5625rem", //placeholder area
            }}
          >
            <img
              src={webinarLogo}
              alt="logo"
              style={{
                width: isMobileDevice ? "3rem" : "6.5625rem",
                height: isMobileDevice ? "3rem" : "6.5625rem",
                borderRadius: "50%",
              }}
            />
          </div>
          <div className={styles.column}>
            <div>{title}</div>
            <div className={styles.info}>
              {!details.ongoingagendaid
                ? description
                : webinarPageData?.agenda?.order.indexOf(
                    details.ongoingagendaid
                  ) !== -1
                ? webinarPageData?.agenda?.mainData[
                    webinarPageData?.agenda?.order.indexOf(
                      details.ongoingagendaid
                    )
                  ].title
                : description}
            </div>
            {/* <div className={styles.info}>{info}</div> */}
            {details.ongoingagendaid ? (
              <div
                onClick={() => setShowSessionDetails(true)}
                className={styles.detailsBtn}
              >
                Session Details
              </div>
            ) : null}
            {showSessionDetails && (
              <SessionDetails setShowSessionDetails={setShowSessionDetails} />
            )}
          </div>
        </div>
        <div>
          {!overlay && (
            <div onClick={handleInviteBtn} className={styles.inviteBtn}>
              <button>Invite</button>
            </div>
          )}
        </div>
      </div>
      {!overlay && showInviteModal && (
        <InviteModal
          from={ContentType2.Webinar}
          type="event"
          details={details}
          handleClose={handleInviteBtnClose}
          customClass={"inviteModal"}
        />
      )}
      {!overlay && (
        <div className={styles.actionSection}>
          {details.isCertificateEnable && (
            <button
              onClick={handleCertificateBtn}
              disabled={!showCertificateBtn}
              className={`btn ${styles.certBtn}`}
            >
              {certificateShowTime.minutes || certificateShowTime.seconds
                ? `Get Your Certificate in ${
                    certificateShowTime.minutes
                      ? `${certificateShowTime.minutes}m ${certificateShowTime.seconds}s`
                      : `${certificateShowTime.seconds}s`
                  }`
                : "Get Your Certificate"}
            </button>
          )}
          <div
            onClick={handleFeedbackOpen}
            className={`${styles.row} ${styles.feedbackBtn}`}
          >
            <img src={feedbackIcon} alt="feedback" className={styles.icon} />
            Feedback
          </div>
          <Feedback
            key={feedbackkey}
            webinarData={details}
            showFeedback={showFeedback}
            addClickAnalytics={addClickAnalytics}
            handleFeedbackClose={handleFeedbackClose}
          />
          {!isOpen && (
            <div
              className={styles.chatBotContainer}
              onClick={() => {
                // setIsChatBotOpen(false);
                scrollTarget("#pageData");
                setIsOpen(true);
              }}
            >
              <div className={styles.qnaBtnIndicator}>
                <img src={QNAImg} alt="" />
                {showPollIndicator && (
                  <div className={styles.pollQAIndicator} />
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {!overlay && showCertificate && (
        <Certificate
          webinarData={details}
          url={webinarPageData.baseInfo.certificateUrl}
          addClickAnalytics={addClickAnalytics}
          handleCertificateClose={handleCertificateClose}
        />
      )}
    </div>
  );
}

export default memo(WebinarHeader);
